import React, { useState } from 'react';
import DatePicker from '~/components/organism/DatePicker';
import TimePicker from '~/components/organism/TimePicker';
import JustificationContainer, {
  Props as JustificationProps,
} from '~/components/atom/JustificationContainer';
import TextButton from '~/components/atom/TextButton';
import formatTimeString from '~/components/page/LFA/utils/formatTimeString';

const text = {
  addTime: 'Tijd toevoegen',
  removeTime: 'Tijd verwijderen',
};

type DateTimePickerProps = {
  direction?: JustificationProps['direction'];
  timeProps: {
    time?: string;
    onTimeChange?: (time: string) => void;
  };
  dateProps: {
    date: string;
    labelDate?: string;
    setInitialTodayDate?: boolean;
    onDateChange: (date: string) => void;
  };
};

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  dateProps: {
    date,
    labelDate = 'Datum',
    setInitialTodayDate = false,
    onDateChange,
  },
  timeProps: { time, onTimeChange },
  direction = 'row',
}) => {
  const [addTime, setAddTime] = useState(false);

  return (
    <JustificationContainer direction={direction} gap="xs" align="end">
      <DatePicker
        label={labelDate}
        value={date}
        onChange={onDateChange}
        setInitialTodayDate={setInitialTodayDate}
      />
      {addTime && onTimeChange && (
        <TimePicker
          value={formatTimeString(time || '')}
          onChange={onTimeChange}
        />
      )}
      {!addTime && (
        <TextButton
          size="medium"
          label={text.addTime}
          icon="plus"
          onClick={() => setAddTime(true)}
        />
      )}
      {addTime && (
        <TextButton
          appearance="danger"
          size="medium"
          label={text.removeTime}
          icon="trashcan"
          onClick={() => {
            setAddTime(false);
            onTimeChange?.('');
          }}
        />
      )}
    </JustificationContainer>
  );
};

export default DateTimePicker;
